import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function kpiHeader(theme: Theme): ComponentStyle {
  return {
    componentName: 'kpiHeader',
    baseStyle: {
      color: theme.colors.muted,
      fontWeight: 600
    },
    variants: {
      primaryGradient: {
        color: 'transparent',
        backgroundImage:
          'linear-gradient(270.98deg, #ffcd4d -5.71%, #fa43bd 102.6%)',
        backgroundClip: 'text',
        alignSelf: 'flex-start'
      },
      banner: {
        fontSize: theme.sizes[0]
      },
      homeKpiCard: {
        fontSize: theme.sizes[-1],
        fontWeight: 400
      }
    }
  };
}
